angular.module('env.data.services.calendar', [])

    .run(function (calendarService) {

    })

    .provider('calendarService', function (EventingMixin) {
        var _this = this;

        this.$get = function ($log, $q, $timeout, $localStorage, $http, authService) {

            /**
             * Gets public holidays for the specified country and year
             * @param countryCode - Code of the Country to get holidays for
             * @param year - Year to get holidays for
             * @returns {HttpPromise} Future object
             */
            _this.getPublicHolidays = function (countryCode, year) {
                var token = authService.getToken();
                if (!token) {
                    $log.error('Can not fetch public holidays info from calendar api. Error: Not authorized.');
                    return [];
                }
                var config = { headers: { Authorization: token } };

                return $http
                    .get(om.config.build.baseUrl + "/calendar/public-holidays/" + countryCode + "/" + year, config)
                    .then(
                        function (resp) {
                            return resp.data ? resp.data : [];
                        },
                        function (error) {
                            $log.error('Can not fetch public holidays info from calendar api. Error: ' + error);
                            return $q.reject(error);
                        });
            };

            /**
             * Gets custom holidays (if the custom holidays file configured on the server)
             * @returns {HttpPromise} Future object
             */
            _this.getCustomHolidays = function () {
                var token = authService.getToken();
                if (!token) {
                    $log.error('Can not fetch custom holidays info from calendar api. Error: Not authorized.');
                    return [];
                }
                var config = { headers: { Authorization: token } };

                return $http
                    .get(om.config.build.baseUrl + "/calendar/custom-holidays", config)
                    .then(
                        function (resp) {
                            return resp.data ? resp.data : [];
                        },
                        function (error) {
                            $log.error('Can not fetch public holidays info from calendar api. Error: ' + error);
                            return $q.reject(error);
                        });
            };

            /**
             * Gets public holidays for the specified country, current and the next year
             * @param countryCode - Code of the Country to get holidays for
             * @returns {!Promise.<Array.<Date>>} Promise of dates array
             */
            _this.getActualPublicHolidays = function (countryCode) {
                var currentYear = new Date().getFullYear();

                return $q.all([_this.getPublicHolidays(countryCode, currentYear),
                _this.getPublicHolidays(countryCode, currentYear + 1)])
                    .then(function (results) {
                        return _.map(_.flatten(results), function (item) {
                            return new Date(item.date);
                        });
                    });
            };

            /**
             * Gets public PLUS custom holidays for the specified country, current and the next year
             * @param countryCode - Code of the Country to get holidays for
             * @returns {!Promise.<Array.<Date>>} Promise of dates array
             */
            _this.getActualPublicAndCustomHolidays = function (countryCode) {
                var currentYear = new Date().getFullYear();

                return $q.all([
                    _this.getCustomHolidays(),
                    _this.getPublicHolidays(countryCode, currentYear),
                    _this.getPublicHolidays(countryCode, currentYear + 1)
                ])
                    .then(function (results) {
                        return _.map(_.flatten(results), function (item) {
                            return new Date(item.date);
                        });
                    });
            };

            return _this;
        };


    })

    ;
